module.exports = __webpack_public_path__ + "32fb7541b5699fe0416ecc9d1c4bb97f.svg";